module.exports = __webpack_public_path__ + "static/01-f875361bdba9b0f8b0fb412aab89c1ac.jpg";